app.service('rankingView', function(_, localStorage, console, modal, loading, front, broker, productPromotionsListModal) {
	var $window,
		$pageHeader,
		headerHeight,
		productListOffset,
		$nav,
		navActive,
		$navToggle,
		navOpen,
		$productList,
		$productDropdown,
		activeProductIndex,
		activeProductHeight,
		$lastProduct;
	var productList = [],
		productsOffset = [],
		dropdownProducts = [];
	let isInit = false;
	let isActive = true;


	function setElements() {
		$window = $(window);
		$pageHeader = $('#top');
		headerHeight = $pageHeader.outerHeight();
		$nav = $('.products-nav');
		navActive, navOpen = false;
		$navToggle = $('.js-show-products');
		productListOffset = $('.product-list').offset().top;
		$productDropdown = $('.product-dropdown');
		$activeProduct = $('#active-dropdown-item');
		$productList = $('.product-list');

		$('.ranking-product').each((i,el) => productList.push(el));
		productList.forEach(el => productsOffset.push(Math.floor(el.offsetTop)));
		$lastProduct = $('#ranking-product-'+productsOffset.length);
		$('.product-dropdown .dropdown-item').each((i, el) => dropdownProducts.push(el))
		activeProductHeight = $(dropdownProducts[0]).outerHeight();
	}

	function setEvents() {
		$navToggle.click(toggleProductsDropdown);
		if(!isInit) {
			_.onScroll(() => {
				scroll();
			});
			$('body').on('click', '.js-scrollto-ranking', function () {
				scrollToElement($(this).parents('.ranking-item').index()+1);
			}).on('click', '.js-dropdown-scrollto-ranking', function () {
				scrollToElement($(this).index()+1);
				closeProductsDropdown();
			}).on('click', '.js-more-promotions', function () {
				productPromotionsListModal.show($(this).data('product-id'), $(this).data('outlet-category-id'));
			});
			isInit = true;
		}

	}

	broker.on('PAGE_CHANGE', function() {
		isActive = front.page() === 'article' && $('#single-ranking').length > 0;
	})

	function scrollToElement(nr) {
		let destination = Math.ceil($('#ranking-product-'+nr).offset().top - activeProductHeight);
		$.scrollTo(destination, 500);
	}

	function toggleProductsDropdown() {
		navOpen = !navOpen;
		if(navOpen) {
			$productDropdown.addClass('active');
			$navToggle.addClass('open');
		} else {
			closeProductsDropdown();
		}
	}

	function closeProductsDropdown() {
		navOpen = false;
		$productDropdown.removeClass('active');
		$navToggle.removeClass('open');
	}

	function scroll() {
		if(!isActive) {
			return
		}
		var active = 0;
		var pageHeaderHeight = $pageHeader.outerHeight();
		var currentScrollPosition = Math.ceil($window.scrollTop() + pageHeaderHeight + activeProductHeight);
		
		if(Math.floor($lastProduct.offset().top) != productsOffset[productsOffset.length-1]) {
			productListOffset = Math.floor($productList.offset().top);
			productsOffset = [];
			productList.forEach(function(el) {
				productsOffset.push(Math.floor($(el).offset().top));
			});
		}

		if(headerHeight != pageHeaderHeight){
			headerHeight = pageHeaderHeight;
			$nav.css({'top': headerHeight, 'max-height': `calc(100vh - ${headerHeight}px)`});
		}

		if(!navActive && currentScrollPosition >= productListOffset) {
			$nav.addClass('active');
			navActive = true;
		} else if (navActive && currentScrollPosition < productListOffset) {
			$nav.removeClass('active');
			navActive = false;
		}

		productsOffset.forEach((elOffset, index) => {
			if(elOffset <= currentScrollPosition) {
				active = index;
			}
		});
		if (activeProductIndex != active) {
            activeProductIndex = active;
            $activeProduct.html($(dropdownProducts[active]).clone().html());
            activeProductHeight = $activeProduct.innerHeight();
		}
	}

	function init() {
		setElements();
		setEvents();
		$('.ranking-other-products').productSlider();
	}

	return {
		init: init
	};
});
